function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import BsDropdown from 'react-bootstrap/es/Dropdown';
import BsDropdownToggle from 'react-bootstrap/es/DropdownToggle';
import BsDropdownMenu from 'react-bootstrap/es/DropdownMenu';
import BsDropdownItem from 'react-bootstrap/es/DropdownItem';
import Chevron from "../../icon-components/chevron";
/**
 * This is the Dropdown component, a direct proxy of
 * [React Bootstrap's Dropdown](https://react-bootstrap.github.io/components/dropdowns/).
 *
 * Previously called DropdownButton (which is still importable)
 *
 * Dropdown.Item and Dropdown.Header are also exported
 */

var Dropdown = function Dropdown(_ref) {
  var id = _ref.id,
      title = _ref.title,
      children = _ref.children,
      show = _ref.show,
      alignRight = _ref.alignRight,
      onSelect = _ref.onSelect,
      onToggle = _ref.onToggle,
      bsPrefix = _ref.bsPrefix,
      withChevron = _ref.withChevron,
      props = _objectWithoutProperties(_ref, ["id", "title", "children", "show", "alignRight", "onSelect", "onToggle", "bsPrefix", "withChevron"]);

  return React.createElement(BsDropdown, {
    show: show,
    bsPrefix: bsPrefix,
    onSelect: onSelect,
    onToggle: onToggle,
    id: id
  }, React.createElement(BsDropdownToggle, props, React.createElement("div", {
    className: "DropdownToggleContent"
  }, React.createElement("div", {
    className: "DropdownToggleLabel"
  }, title), withChevron && React.createElement("div", {
    className: "DropdownToggleChevron"
  }, React.createElement(Chevron, null)))), React.createElement(BsDropdownMenu, {
    alignRight: alignRight
  }, children));
};

Dropdown.displayName = 'Dropdown';
Dropdown.propTypes = {
  /**
   * Set an id
   */
  id: PropTypes.string,

  /**
   * This should be an array of DropdownItem's use: <Dropdown.Item>Option 1</Dropdown.Item>
   */
  children: PropTypes.any,

  /**
   * Disabled state
   */
  disabled: PropTypes.bool,

  /**
   * Align the menu right
   */
  alignRight: PropTypes.bool,

  /**
   * Is the menu open by default?
   */
  show: PropTypes.bool,

  /**
   * onToggle callback
   */
  onToggle: PropTypes.func,

  /**
   * onSelect callback
   */
  onSelect: PropTypes.func,

  /**
   * The theme of the dropdown's toggle button
   */
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark']),

  /**
   * The label displayed in the dropdown's toggle button
   */
  title: PropTypes.node.isRequired,

  /**
   * Change the underlying component CSS base class name and modifier class names prefix. This is an escape hatch for working with heavily customized bootstrap css.
   */
  bsPrefix: PropTypes.string,

  /**
   * Show the chevron in the menu.
   */
  withChevron: PropTypes.bool
};
Dropdown.defaultProps = {
  variant: 'secondary',
  disabled: false,
  withChevron: true
};
Dropdown.Header = BsDropdown.Header;
Dropdown.Header.displayName = 'DropdownHeader';
Dropdown.Item = BsDropdownItem;
Dropdown.Item.displayName = 'DropdownItem';
export default Dropdown;